export default {"src":"/_next/static/media/logo.d0ec2460.svg","height":75,"width":384,"blurWidth":0,"blurHeight":0};